import { ChainItem, Goods, Order, orderStatus, PaymentMode } from "@/requests/requests"
import { create } from "zustand"

export type WalletType = "metamask" | "tronLink" | "broearnWallet" | "walletconnect" | "okx" | "trust"

export interface StoreOrder extends Omit<Order, "status"> {
    status: Order["status"] | ""
}

export interface Payment {
    chains: ChainItem[]
    chainId: string
    chainItem: ChainItem & {currency_id: string} | null
    resultVisible: boolean
    goods: Goods
    order: StoreOrder
    loopOrder: StoreOrder
    _404: boolean

    setChains(chains: ChainItem[]): void
    setChainId(chainId: string): void
    setChainItem(chainItem: ChainItem & {currency_id: string} | null): void
    checkToken(chainItem: ChainItem & {currency_id: string} | null): void
    setGoods(goods: Goods): void
    setResultVisible(resultVisible: boolean): void
    setOrder(order: Order): void
    setLoopOrder(loopOrder: Order): void
    set404(_404: boolean): void
}

const usePay = create<Payment>(set => ({
    chains: [],
    chainId: "",
    chainItem: null,
    resultVisible: false,
    _404: false,
    order: {
        amount: "",
        chain: "",
        chain_id: 0,
        contract: "",
        decimal: 0,
        mode: "contract" as PaymentMode,
        pay_address: "",
        time_expire: 0,
        fiat_name: "",
        fiat_amount: "",
        token: "",
        trade_no: "",
        contract_pay_address: "",
        status: "",
        equity: 1,
        out_trade_no: "",
        create_time: 0,
        need_confirms: 0,
        already_confirms: 0,
        chain_info: {
            rpc: "",
            abi: "",
            browser_url: "",
            decimal: 0,
            token: ""
        }
    },
    loopOrder: {
        amount: "",
        chain: "",
        chain_id: 0,
        contract: "",
        decimal: 0,
        mode: "contract",
        pay_address: "",
        time_expire: 0,
        fiat_name: "",
        fiat_amount: "",
        token: "",
        trade_no: "",
        equity: 1,
        contract_pay_address: "",
        status: orderStatus["TO-BE-PAID"],
        out_trade_no: "",
        create_time: 0,
        need_confirms: 0,
        already_confirms: 0,
        chain_info: {
            rpc: "",
            abi: "",
            browser_url: "",
            decimal: 0,
            token: ""
        }
    },
    goods: {
        amount: "0.001",
        image: require('@/assets/goodPlaceholder.jpg'),
        name: "White-label product",
        status: "TO-BE-PAID",
        symbol: "USD",
        app_name: "",
        app_icon: require("@/assets/Merchant.png")
    },
    setChains(chains) { set({ chains }) },
    setChainId(chainId) { set({ chainId }) },
    setChainItem(chainItem) { set({ chainItem }) },
    checkToken(chainItem) { set({ chainItem }) },
    setGoods(goods) { set({ goods }) },
    setResultVisible(resultVisible) { set({ resultVisible }) },
    setOrder(order) { set({ order }) },
    setLoopOrder(loopOrder) { set({ loopOrder }) },
    set404(_404) { set({ _404 }) }
}))

export default usePay
